module.exports = __webpack_public_path__ + "img/locations_layout4.18186939.png";